import { useEffect, useState } from 'react'
import { io } from 'socket.io-client'

export const useFinisherSocket = (url) => {
  const [updates, setUpdates] = useState([])
  const [finisherData, setFinisherData] = useState(null)

  useEffect(() => {
    const socket = io(url)

    socket.emit('digitalToPrint', 'OlivierTest', (data) => {
      console.log('Finisher Data:', data)
      setFinisherData(data)
    })

    socket.on('update', (data) => {
      //console.log('Received change:', data)
      setUpdates((prevUpdates) => [...prevUpdates, data])
    })

    return () => {
      socket.disconnect()
    }
  }, [url])

  return { updates, finisherData }
}

export default useFinisherSocket
